import { render, staticRenderFns } from "./loginTrain.vue?vue&type=template&id=02c5311d&scoped=true"
import script from "./loginTrain.vue?vue&type=script&lang=js"
export * from "./loginTrain.vue?vue&type=script&lang=js"
import style0 from "./loginTrain.vue?vue&type=style&index=0&id=02c5311d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c5311d",
  null
  
)

export default component.exports